import React, { useContext, useEffect, useState } from "react";
import StoreMenu from "../../StoreMenu";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserData } from "../../../utils/localStorage";
import {
  getBrandStore,
  getBrandUsers,
  getStoreUsersStoreConfig,
} from "../../../services/StoreUsers/PostStoreUsers";
import { formatDate } from "../../../constants/DateUtil/DateUtil";
import { ProgressSpinner } from "primereact/progressspinner";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import StoreUserStatusChange from "./StoreUserStatusChange";
import StoreUserAddModal from "./StoreUserAddModal";
import AdminMenu from "../../AdminMenu";

const StoreConfigUser = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id, StoreData } = location.state || {}; // Fallback to prevent undefined errors

  const [visible, setVisible] = useState(false);
  const [storeUserData, setStoreUserData] = useState([]);
  const [storeUserList, setStoreUserList] = useState([]);
  const [storeUserAddModalVisible, setStoreUserAddModalVisible] =
    useState(false);
  const [loading, setLoading] = useState(false);

  const { brandProfileData, userProfileRole } = getUserData();
    const userRole = userProfileRole;
  let brandId = brandProfileData.id;

  const fetchPriceCode = () => {
    setLoading(true);
    getStoreUsersStoreConfig(brandId, id)
      .then((response) => {
        if (!response.data.error) {
          const users = response.data;
          setStoreUserData(users);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });

    getBrandUsers(brandId)
      .then((response) => {
        if (!response.data.error) {
          const users = response.data;
          const filterUsers = users.filter(
            (item) =>
              item.role !== "ROLE_WHATSAPP_USER" &&
              item.role !== "ROLE_WEB_USER"
          );
          setStoreUserList(filterUsers);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    fetchPriceCode();
  }, []);

  const receiveDataFromBrandStoreUserStatusChange = ({success}) => {
    if (success) {
      fetchPriceCode();
    }
  };

  const renderStoreUserCardItem = (data) => {
    return data?.map((item, index) => {
      const storeRole = item.user.role.replace(/_/g, " ");
      return (
        <div>
          <div className="flex-1 ">
            <div className="m-4 shadow-4">
              <div className="flex flex-1">
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    User Name :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {item.user.firstName + " " + item.user.lastName}
                  </p>
                </div>
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    User Id :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {item.user.userLoginId}
                  </p>
                </div>
                <div
                  className="flex-1 px-3 py-1 flex justify-content-between"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <div>
                    <p
                      className="text-md font-normal capitalize"
                      style={{ color: "#75879B" }}
                    >
                      Role :
                    </p>
                    <p className="text-lg font-medium capitalize">
                      {storeRole}
                    </p>
                  </div>
                </div>
              
                <div
                  className="flex-1 px-3 py-1 flex justify-content-between"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <div>
                    <p
                      className="text-md font-normal capitalize"
                      style={{ color: "#75879B" }}
                    >
                      Status
                    </p>
                    <p className="text-lg font-medium capitalize">{item.status === "ACTIVE" ? "Active" : "DeActive"}{" "}</p>
                  </div>
                  {userRole === "BY_FRANCHISE_ADMIN" ? "" : <StoreUserStatusChange
                    status={item.status}
                    sendDataToStoreConfig={
                      receiveDataFromBrandStoreUserStatusChange
                    }
                    editData={item}
                    brandId={brandId}
                    storeId={id}
                  />}
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() =>
                    navigate("/StoreConfigList", {
                      state: {
                        id: id,
                        StoreData: StoreData,
                      },
                    })
                  }
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
                Store User
              </p>
            </div>
          </div>
          {userRole === "BY_FRANCHISE_ADMIN" ? (
            ""
          ) : (
            <div
              className="flex justify-content-center align-items-center cursor-pointer mr-4"
              onClick={() => setStoreUserAddModalVisible(true)}
            >
              <img src="images/plus.png" alt="plus" style={{ width: 30 }} />
            </div>
          )}
          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div>
        {loading ? (
          <div style={{ flex: 1 }}>
            <div className="text-center">
              <ProgressSpinner
                style={{ width: "70px", height: "70px" }}
                strokeWidth="4"
                fill="var(--surface-ground)"
                animationDuration="2s"
              />
            </div>
          </div>
        ) : storeUserData?.length > 0 ? (
          <div>
            <div>{renderStoreUserCardItem(storeUserData)}</div>
          </div>
        ) : (
          <div className="flex justify-content-center align-items-center">
            <p className="text-xl font-medium">No User Found</p>
          </div>
        )}
      </div>
      <StoreUserAddModal
        storeUserAddModalVisible={storeUserAddModalVisible}
        setStoreUserAddModalVisible={setStoreUserAddModalVisible}
        sendDataToStoreConfig={receiveDataFromBrandStoreUserStatusChange}
        brandId={brandId}
        storeUserList={storeUserList}
        storeId={id}
      />

      <AdminMenu setVisible={setVisible} visible={visible} />
    </div>
  );
};

export default StoreConfigUser;
